import * as ActionTypes from '../store/ActionTypes';
import { axiosInstance } from './api';

export const actionCreators = {
    getClubs: (clubs) => ({ type: ActionTypes.getClubs, payload: clubs }),
    getAllClubs: (clubs) => ({ type: ActionTypes.getAllClubs, payload: clubs }),
    getClub: (club) => ({ type: ActionTypes.getClub, payload: club }),
    updateClub: (club) => ({ type: ActionTypes.updateClub, payload: club }),
    createClub: (club) => ({ type: ActionTypes.createClub, payload: club }),
    setClub: (club) => ({ type: ActionTypes.getClub, payload: club }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response }),
    getEnrollmentUrl: (clubId, url) => ({ type: ActionTypes.getEnrollmentUrl, payload: { clubId, url } }),
    addCharge: (clubId, charge, amount) => ({ type: ActionTypes.addCharge, payload: { clubId, charge, amount } }),
    updateRefund: (response) => ({ type: ActionTypes.updateRefund, payload: response }),
    addRefund: (response) => ({ type: ActionTypes.addRefund, payload: response }),
};

export const getClubs = (callback, context, filter) => {
    return dispatch => {
        const url = `Club/SearchClubs?filter=${filter}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getClubs(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getClubsPaginated = (filter, pageNumber, pageSize, orderBy, descending, onlyActive) => {
    const url = `Club/SearchClubsPaginatedAsync?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}&onlyActive=${onlyActive}`;
    return axiosInstance().get(url);
}

export const getClub = (callback, context, id) => {
    return dispatch => {
        const url = `Club/GetClubById/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getClubs(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getAllClubs = (callback, context, onlyActive) => {
    return dispatch => {
        let url = `Club/GetClubsAsync`;
        if (onlyActive) {
            url += `?onlyActive=${onlyActive}`;
        }
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getClubs(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getAllowedClubs = (callback, context, id) => {
    return dispatch => {
        const url = `Club/GetAllowedParents?id=${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getClubs(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

// } else {
//     console.log("withfilter");
//     var pageIndexed = page + 1;
//     const url = `Club/SearchClubsPaginatedAsync?pageNumber=${pageIndexed}&filter=${filter}`;
//     return axiosInstance().get(url).then(response => {
//         console.log(response, "HOLA");
//         if(response.data.success){
//         console.log("SUCCESS");
//         dispatch(actionCreators.getClubs(response.data.data))
//         callback(response, context);
//         }
//     }).catch(response => callback(response.response, context));
// }

export const updateClub = (club) => {
    return dispatch => {
        console.log(club);
        const url = `Club/PutAsync`;
        return axiosInstance().put(url, club).then(response => {
            dispatch(actionCreators.updateClub(response))
            console.log(response, "response")
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}

// export const setClub = (club) => {return dispatch => {

//     dispatch(actionCreators.getClub(club));
//     }
// }

// async getClub(id){
//     const url = `/Club/GetClubById/${id}`;
//     return axiosInstance.get(url).then(response => response.data);
// }

// async updateClub(club){
//     const url = `/Club/PutAsync`;
//     console.log(club.clubId)
//     console.log(club);
//     return axiosInstance.put(url, club).then(response => response.data);
// }

export const createClub = (club) => {
    return dispatch => {
        const url = `Club/PostAsync`;
        return axiosInstance().post(url, club).then(response => {
            dispatch(actionCreators.updateClub(response))
            console.log(response, "response")
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

// async createClub(club){
//     const url = `/Club/PostAsync`;
//     return axiosInstance.post(url, club).then(response => response.data);    
// }

export const initiateEnrollment = (clubId) => {
    return dispatch => {
        const url = `Stripe/enroll?clubId=${clubId}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getEnrollmentUrl(clubId, response.data));
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const StripeUrl = (callback, context, clubId) => {
    return dispatch => {
        const url = `Stripe/enroll?clubId=${clubId}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getEnrollmentUrl(clubId, response.data));
            callback(response, context);
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}


export const testCharge = (clubId, amount) => {
    return dispatch => {
        const url = `Stripe/charge?clubId=${clubId}&amount=${amount}`;
        return axiosInstance().post(url).then(response => {
            dispatch(actionCreators.addCharge(clubId, response.data, amount));
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const testRefund = (clubId, chargeId, amount) => {
    return dispatch => {
        const url = `Stripe/refund?clubId=${clubId}&chargeId=${chargeId}&amount=${amount}`;
        return axiosInstance().post(url).then(response => {
            dispatch(actionCreators.addRefund(clubId, response.data));
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const RefundByGift = (clubId, stripeChargeId, amount) => {
    return dispatch => {
        const url = `Stripe/refund?clubId=${clubId}&chargeId=${stripeChargeId}&amount=${amount}`;
        return axiosInstance().post(url).then(response => {
            dispatch(actionCreators.updateRefund(response));
            //dispatch(actionCreators.addRefundGift(saleId, response.data));
            //if (response.data.success) {
            //    window.location.reload();
            //    alert(response.data);
            //} else {
            //    //alert(response.data.errors[0].message);
            //    //this.setState({ loading: false });
            //}
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const RefundChargeByGift = (clubId, recipientId) => {
    return dispatch => {
        const url = `Stripe/refundCharge?clubId=${clubId}&recipientId=${recipientId}`;
        return axiosInstance().post(url).then(response => {
            dispatch(actionCreators.updateRefund(response));
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateRefund = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateRefund(response));
    }
}